const NODES = {
  kolwezi: { x: 571, y: 255, label: "Kolwezi · DRC", role: "mine", coord: "25.5°E 10.7°S" },
  kigali: { x: 584, y: 234, label: "Kigali · Rwanda", role: "mine", coord: "30.1°E 1.9°S" },
  dakar: { x: 452, y: 196, label: "Dakar · Senegal", role: "mine", coord: "17.4°W 14.7°N" },
  dubai: { x: 654, y: 171, label: "Dubai DBX", role: "hub", coord: "55.3°E 25.2°N" },
  london: { x: 500, y: 110, label: "London", role: "vault", coord: "0.1°W 51.5°N" },
  zurich: { x: 524, y: 119, label: "Zurich", role: "vault", coord: "8.5°E 47.4°N" },
  newyork: { x: 294, y: 135, label: "New York", role: "vault", coord: "74.0°W 40.7°N" },
  miami: { x: 277, y: 170, label: "Miami", role: "vault", coord: "80.2°W 25.8°N" },
  hongkong: { x: 817, y: 178, label: "Hong Kong", role: "vault", coord: "114.2°E 22.3°N" },
};

const ARCS = [
  ["kolwezi", "dubai"], ["kigali", "dubai"], ["dakar", "dubai"],
  ["dubai", "london"], ["dubai", "zurich"], ["dubai", "hongkong"],
  ["london", "newyork"], ["newyork", "miami"],
];

const arcPath = (a, b) => {
  const p1 = NODES[a], p2 = NODES[b];
  const cx = (p1.x + p2.x) / 2;
  const cy = Math.min(p1.y, p2.y) - Math.abs(p1.x - p2.x) * 0.22 - 24;
  return `M ${p1.x} ${p1.y} Q ${cx} ${cy} ${p2.x} ${p2.y}`;
};

const NodeMark = ({ n, testid }) => {
  const common = "cursor-pointer";
  if (n.role === "mine")
    return (
      <g className={common} data-testid={testid}>
        <title>{`${n.label} — ${n.coord}`}</title>
        <rect x={n.x - 5} y={n.y - 5} width="10" height="10" transform={`rotate(45 ${n.x} ${n.y})`} fill="#D4AF37" />
        <circle cx={n.x} cy={n.y} r="12" fill="none" stroke="#C9A227" strokeOpacity="0.5" className="node-pulse" />
      </g>
    );
  if (n.role === "hub")
    return (
      <g className={common} data-testid={testid}>
        <title>{`${n.label} — ${n.coord}`}</title>
        <circle cx={n.x} cy={n.y} r="7" fill="#0A0A0B" stroke="#E8C85A" strokeWidth="2" />
        <circle cx={n.x} cy={n.y} r="14" fill="none" stroke="#C9A227" strokeOpacity="0.5" className="node-pulse" />
      </g>
    );
  return (
    <g className={common} data-testid={testid}>
      <title>{`${n.label} — ${n.coord}`}</title>
      <rect x={n.x - 4.5} y={n.y - 4.5} width="9" height="9" fill="#997A19" stroke="#D4AF37" strokeWidth="1" />
    </g>
  );
};

export const CorridorMap = () => (
  <div data-testid="corridor-map" className="card-line bg-[#0A0A0B] p-4 sm:p-8 relative overflow-hidden">
    <svg viewBox="0 0 1000 400" className="w-full h-auto" role="img" aria-label="Zorem corridor map: mine gates in DRC, Rwanda and Senegal connecting via Dubai to vaults in London, Zurich, New York, Miami and Hong Kong">
      {[80, 160, 240, 320].map((y) => (
        <line key={y} x1="0" y1={y} x2="1000" y2={y} stroke="#C9A227" strokeOpacity="0.07" strokeDasharray="2 6" />
      ))}
      {[125, 250, 375, 500, 625, 750, 875].map((x) => (
        <line key={x} x1={x} y1="0" x2={x} y2="400" stroke="#C9A227" strokeOpacity="0.07" strokeDasharray="2 6" />
      ))}
      {ARCS.map(([a, b]) => (
        <path key={`${a}-${b}`} d={arcPath(a, b)} fill="none" stroke="#C9A227" strokeOpacity="0.45" strokeWidth="1.2" strokeDasharray="5 7" className="corridor-arc" />
      ))}
      {Object.entries(NODES).map(([id, n]) => (
        <NodeMark key={id} n={n} testid={`map-node-${id}`} />
      ))}
      {Object.entries(NODES).map(([id, n]) => (
        <text key={`t-${id}`} x={n.x + 12} y={n.y - 8} fill="#A1A1AA" fontSize="11" fontFamily="JetBrains Mono, monospace" letterSpacing="1">
          {n.label}
        </text>
      ))}
    </svg>
    <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3 font-mono2 text-[10px] uppercase tracking-[0.2em] text-zinc-500">
      <span className="flex items-center gap-2"><span className="w-2 h-2 rotate-45 bg-[#D4AF37] inline-block" /> Mine gate</span>
      <span className="flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full border-2 border-[#E8C85A] inline-block" /> Transit hub</span>
      <span className="flex items-center gap-2"><span className="w-2 h-2 bg-[#997A19] border border-[#D4AF37] inline-block" /> Vault / fulfillment</span>
    </div>
  </div>
);
